const Empfehlung = (props) => {
    const color = props && props.color ? props.color : 'yellow';
    // console.log('Empfehlung', color);
    return (
        <><b style={{color: color, fontSize: 'x-large' }}>*</b></>
    )
}

export default Empfehlung;